import { AuthContext, AuthContextValue } from 'ui/components/AuthProvider';
import { useContext } from 'react';

const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);

  if (!context) throw new Error('useAuth must be used inside AuthContext');

  return context;
};

export default useAuth;
